<template>
  <div class="image-grid-container" :style="{ 'page-break-inside': 'avoid' }">
    <div
      class="image-row"
      v-for="(rowImages, rowIdx) in rows"
      :key="'row-' + rowIdx"
    >
      <ImageMedia
        v-for="(mediaObject, imgIdx) in rowImages"
        :key="'img-' + rowIdx + '-' + imgIdx"
        :src="mediaObject"
        :width="190"
        :height="190"
        class="grid-img"
        draggable="false"
        loading="eager"
      />
    </div>
  </div>
</template>

<script>
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'

export default {
  name: 'ImageMediaPrintGrid',

  components: {
    ImageMedia,
  },

  props: {
    mediaObjects: {
      type: Array,
      required: true,
    },
  },
  computed: {
    rows() {
      const firstRow = this.mediaObjects.slice(0, 3)
      const secondRow =
        this.mediaObjects.length > 3 ? this.mediaObjects.slice(3, 5) : []
      return secondRow.length > 0 ? [firstRow, secondRow] : [firstRow]
    },
  },
}
</script>

<style lang="scss" scoped>
.image-grid-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 0;
  width: 100%;
  page-break-inside: avoid;
}
.image-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}
.image-row:last-child {
  margin-bottom: 0;
}
.grid-img {
  width: 190px;
  height: 190px;
  object-fit: cover;
  margin: 0;
  padding: 0;
  border: none;
  box-sizing: border-box;
  page-break-inside: avoid;
}
</style>
